import { SvgIcon, SvgIconProps } from "@mui/material";
import * as React from "react";

type PhosphorIconComponent = React.ComponentType<{
  size?: number | string;
  color?: string;
  weight?: "thin" | "light" | "regular" | "bold" | "fill" | "duotone";
  [key: string]: unknown;
}>;

const FONT_SIZE_MAP = { small: 20, medium: 24, large: 28 };

interface PhosphorMuiIconProps extends Omit<SvgIconProps, "component"> {
  
  icon: PhosphorIconComponent;
  
  weight?: "thin" | "light" | "regular" | "bold" | "fill" | "duotone";
}


export function PhosphorMuiIcon({
  icon: Icon,
  weight = "regular",
  ...svgIconProps
}: PhosphorMuiIconProps) {
  return (
    <SvgIcon
      component={(props: Record<string, unknown>) => {
        const fs = props.fontSize as keyof typeof FONT_SIZE_MAP | number;
        const size =
          typeof fs === "number" ? fs : FONT_SIZE_MAP[fs] ?? 24;
        return (
          <Icon
            {...props}
            color="currentColor"
            size={size}
            weight={weight}
          />
        );
      }}
      inheritViewBox
      {...svgIconProps}
    />
  );
}
